import { render } from "./BossBlitz.vue?vue&type=template&id=1a4583dc"
import script from "./BossBlitz.vue?vue&type=script&lang=js"
export * from "./BossBlitz.vue?vue&type=script&lang=js"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__